import Vue from 'vue';

import { RouteType } from './constants';

export type MenuItemObject = {
	name: string,
	route?: string | ((vue: Vue) => string),
	routeType?: RouteType,
	orderAlphabetically?: boolean,
	newTab?: boolean,
	list?: MenuItemObject[],
	delimited?: boolean,
};

export class MenuBase {
	items: MenuItem[] = [];

	add(item: MenuItem): MenuItem {
		this.items.push(item);

		return item;
	}

	addItem(item: MenuItemObject, icon: string | null, routeType: RouteType = RouteType.listName) {
		if (item.routeType !== undefined) {
			// eslint-disable-next-line no-param-reassign
			({ routeType } = item);
		}

		const menuItem = this.add(new MenuItem(
			item.name,
			item.route || null,
			routeType,
			icon,
			'orderAlphabetically' in item ? item.orderAlphabetically : true,
			item.newTab,
			item.delimited,
		));

		if (item.list) {
			item.list.forEach((i) => menuItem.addItem(i, null, routeType));
		}
	}
}

export class MenuItem extends MenuBase {
	constructor(
		public name: string,
		public route: string | null | ((vue: Vue) => string),
		public routeType: RouteType,
		public icon: string | null = null,
		public orderAlphabetically: boolean = true,
		public newTab: boolean = routeType === RouteType.url,
		public delimited: boolean = false,
		public visible: boolean = false,
	) {
		super();
	}
}


export const menuBase = new MenuBase();
